import React from "react";
import Layout from "../components/Layout";
import MetaTags from "../lib/MetaTags";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Terms() {
  return (
    <Layout>
      <MetaTags title="Terms of Service" description="Terms of Service for Chicago Electronics Guide." />
      <section className="ceg-container py-12">
        <Breadcrumbs items={[{ to: "/", label: "Home" }, { label: "Terms" }]} />
        <h1 className="font-['Outfit'] font-black tracking-tighter text-5xl md:text-6xl mt-4">Terms of Service</h1>
        <p className="text-sm text-[#5C5C5C] mt-2">Last updated: February 1, 2026</p>

        <div className="article-prose mt-8 max-w-3xl">
          <p>By accessing Chicago Electronics Guide, you agree to these Terms of Service.</p>
          <h2>Editorial information, not professional advice</h2>
          <p>Articles on this site are general consumer information. They are not legal, financial, technical, or repair advice. Prices, store hours, programs, and policies can change at any time — always verify directly with the businesses and services mentioned before making decisions.</p>
          <h2>Third-party mentions</h2>
          <p>We mention many businesses, services, and platforms across our guides — including local Chicago electronics shops, national mail-in services, manufacturers, and recyclers. Mention does not constitute endorsement. We have no formal commercial relationship with these businesses unless explicitly disclosed.</p>
          <h2>User-submitted content</h2>
          <p>Information you submit via the contact form is used to respond to you and improve our content. Do not submit confidential or sensitive personal data.</p>
          <h2>Intellectual property</h2>
          <p>All editorial content on this site is original work of Chicago Electronics Guide unless otherwise attributed. You may quote brief excerpts with attribution. Full-article reproduction requires permission.</p>
          <h2>Limitation of liability</h2>
          <p>We make no warranty as to the accuracy or completeness of information on this site. Your use of the information is at your own risk. We are not liable for losses arising from reliance on the content.</p>
          <h2>External links</h2>
          <p>This site contains links to external websites. We are not responsible for the content, policies, or practices of those sites.</p>
          <h2>Changes</h2>
          <p>We may update these terms periodically. Continued use of the site indicates acceptance of the current terms.</p>
          <h2>Contact</h2>
          <p>Questions? Reach us via the Contact page.</p>
        </div>
      </section>
    </Layout>
  );
}
